import DataPartnershipPage from "@/components/getListed/chainListing/DataPartnershipPage"

type Props = {}

const index = (_props: Props) => {
  return <DataPartnershipPage />
}

export default index
